package com.veldekar.pages.log

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.PageContext
import com.veldekar.components.layouts.SessionPageLayout
import com.veldekar.components.logs.Log_2025_04_12_Day_1
import com.veldekar.components.logs.Log_2025_04_12_Day_2
import com.veldekar.components.logs.Log_2025_04_12_Day_3
import com.veldekar.components.widgets.SessionDayHeader
import kotlinx.datetime.LocalDate

@Page(routeOverride = "/2025-04-12")
@Composable
public fun Log_2025_04_12(ctx: PageContext) {
    SessionPageLayout(
        ctx = ctx,
        title = "🦞 Shell-shocked ⚡️",
        ogTitle = "🦞 Shell-shocked ⚡️",
        date = LocalDate(2_025, 4, 12),
        ogDescription = "Lovecraftian lobsters mercilessly brutalized and dismembered by friends of the forest.",
        ogImage = "images/banshirToSeshiss.webp",
        ogImageWidth = 1_200,
        ogImageHeight = 630,
        ogImageAlt = "A hand-drawn map on grid paper showing a path from Banshir to Seshiss, with symbols representing land cover features in a marsh.",
    ) {
        SessionDayHeader(dayId = "newgrowth-87", dateString = "Newgrowth 87")
        Log_2025_04_12_Day_1()
        SessionDayHeader(dayId = "newgrowth-88", dateString = "Newgrowth 88")
        Log_2025_04_12_Day_2()
        SessionDayHeader(dayId = "newgrowth-89", dateString = "Newgrowth 89")
        Log_2025_04_12_Day_3()
    }
}
